import { NgModule, PLATFORM_ID } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { isPlatformBrowser } from "@angular/common";

import { NgxGoogleAnalyticsModule, NGX_GOOGLE_ANALYTICS_SETTINGS_TOKEN, IGoogleAnalyticsSettings, NgxGoogleAnalyticsRouterModule } from "ngx-google-analytics";

import { GlobalConstants } from "./global-constants";

// 1) Creamos la factoría para obtener el ID dinámico en runtime
export function analyticsSettingsFactory(platformId: any): IGoogleAnalyticsSettings {
  const settings: IGoogleAnalyticsSettings = {
    trackingCode: "",
  };

  if (isPlatformBrowser(platformId)) {
    const host = window.location.hostname;
    const envObject = new GlobalConstants(host) as any;
    settings.trackingCode = envObject.idAnalytic || "";
  } else {
    const envObject = new GlobalConstants("tribunanoticias") as any;
    settings.trackingCode = envObject.idAnalytic || "";
  }

  return settings;
}

@NgModule({
  imports: [
    BrowserModule,

    // 2) Iniciamos GA con un string vacío; luego se "pisará" por la factoría.
    NgxGoogleAnalyticsModule.forRoot(""),
    // Con esto se registran automáticamente los page_view al cambiar de ruta.
    NgxGoogleAnalyticsRouterModule,
  ],
  providers: [
    // 3) Sobrescribimos la config con el provider
    {
      provide: NGX_GOOGLE_ANALYTICS_SETTINGS_TOKEN,
      useFactory: analyticsSettingsFactory,
      deps: [PLATFORM_ID],
    },
  ],
})
export class GaModule {}
